<template>
    <cart-base>
        <template slot-scope="{ discounts, items, price }">
            <div class="card">
                <div class="card-header">
                    <h3>
                        {{ __('Cart') }}
                    </h3>
                </div>
                <div
                    v-if="!items.length"
                    class="card-body"
                >
                    {{ __('Your cart is empty!') }}
                </div>
                <div
                    v-if="items.length"
                    class="card-body"
                >
                    <div>
                        <cart-item
                            v-for="item in items"
                            :key="item.id.identifier"
                            :item="item"
                        />

                        <div
                            v-if="discounts.length"
                            class="cart-discounts"
                        >
                            <p class="card-subtitle">
                                {{ __('Kedvezmények') }}
                            </p>
                            <component
                                :is="discount.type"
                                v-for="(discount, key) in discounts"
                                :key="key"
                                :discount="discount"
                            />
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <div>
                                    <span class="item-label">{{ __('Total net price:') }}</span>
                                    <span class="item-price">{{ formatNegativePrice(price.net) | currency }}</span>
                                </div>

                                <div>
                                    <span class="item-label">{{ __('Total vat value:') }}</span>
                                    <span class="item-price">{{ formatNegativePrice(price.vatValue) | currency }}</span>
                                </div>

                                <div>
                                    <span class="item-label">{{ __('Total gross price:') }}</span>
                                    <span class="item-price">{{ formatNegativePrice(price.gross) | currency }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="container p-0">
                            <portal-target
                                v-if="portalAvailable"
                                name="cart-below-coupon-redeem"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </cart-base>
</template>

<script>
export default {}
</script>
